import {GlobalAlertItem} from './types';

/**
 * Shared visibility gate for the app-root GlobalAlertBanner and BrandHeader
 * safe-area inset. Must stay in lockstep with the banner's render condition.
 *
 * - `isGlobal` → every route
 * - otherwise → homepage / home route only
 */
export function isGlobalAlertBannerVisible(
  alert: GlobalAlertItem | null | undefined,
  isHomeRoute: boolean,
): alert is GlobalAlertItem {
  return Boolean(alert && (alert.isGlobal || isHomeRoute));
}
